module.exports = __webpack_public_path__ + "img/heart2heart-poster3.eff71bbd.jpg";